import { render, staticRenderFns } from "./FerryEdit.vue?vue&type=template&id=358d7278"
import script from "../../controllers/ferry/ferry-edit.js?vue&type=script&lang=js&external"
export * from "../../controllers/ferry/ferry-edit.js?vue&type=script&lang=js&external"
import style0 from "./FerryEdit.vue?vue&type=style&index=0&id=358d7278&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports